import { defineComponent as _defineComponent } from 'vue'
import { getProvidedApp } from '~/base/utils/provided-getter'
import { LocalizationData, LocalizationPath } from '@tokyojob/core'
import { CGoogleSignInButton, getLocalization, CFacebookSignInButton } from '@tokyojob/frontend-components'
import { IApp } from '~/types/nuxt'
import { LocalizationService } from '../../../../../../../core/src/modules'


export default /*#__PURE__*/_defineComponent({
  __name: 'c-social-login.component',
  props: {
  fbBtnText: {
    type: String,
    required: true
  },
  googleBtnText: {
    type: String,
    required: true
  }
},
  setup(__props) {

const props = __props;

// import { ref, computed, onMounted } from 'vue'
const App: IApp = getProvidedApp()
const localization: LocalizationData = getLocalization(App)



return { __sfc: true,App, localization, props, CGoogleSignInButton, CFacebookSignInButton }
}

})